import { getApiBaseUrl, getApiToken } from "./init";

export class ApiRequestError extends Error {
    constructor(
        public requestUrl: string,
        message: string,
        public errorCode?: string,
        public httpStatus?: number,
    ) {
        super(message);
    }
}

export async function apiRequest<T extends object>(
    url: string,
    method: "post" | "get",
    options?: RequestInit,
): Promise<T> {
    const repl = await fetch(`${getApiBaseUrl()}/${url}`, {
        method,
        headers: {
            "Content-Type": "application/json",
            Authorization: `token ${getApiToken()}`,
        },
        ...options,
    });

    let resp: T | ApiErrorResponse;
    try {
        resp = (await repl.json()) as T | ApiErrorResponse;
    } catch (e) {
        throw new ApiRequestError(
            url,
            `Can't decode API response as JSON: ${(e as Error).message}`,
            undefined,
            repl.status,
        );
    }

    if (
        "errorCode" in resp &&
        typeof resp.errorCode === "string" &&
        typeof resp.errorMessage === "string"
    ) {
        throw new ApiRequestError(url, resp.errorMessage, resp.errorCode, repl.status);
    }

    if (!repl.ok) {
        throw new ApiRequestError(url, "API request failed", undefined, repl.status);
    }

    return resp as T;
}

interface ApiErrorResponse {
    errorCode: string;
    errorMessage: string;
}
